import styled from 'styled-components';

import { BLACK, BG_GRAY } from '../../../../styles/variables.style';
import media from '../../../../styles/media.style';

export const Wrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 40px;
  padding: 0;

  ${media.tabletL`
    margin-top: 100px;
  `};
`;

export const Container = styled.div`
  width: 100%;
  padding: 80px 20px;
  text-align: center;
  background: ${BG_GRAY.COMMON_1};

  ${media.tabletL`
    padding: 80px 40px;
  `};
`;

export const Title = styled.h5`
  position: relative;
  text-transform: uppercase;
  margin-bottom: 20px;
  letter-spacing: 0.1em;
  text-align: center;
  font-size: 14px;
  line-height: 16px;
  color: ${BLACK};

  ${media.tabletL`
    margin-bottom: 25px;
    font-size: 18px;
    line-height: 20px;
  `};
`;

export const Hr = styled.div`
  width: 40px;
  height: 2px;
  background: ${BLACK};
  margin: 0 calc(50% - 15px);
`;

export const ContentWrapper = styled.div`
  text-align: center;
`;

export const Name = styled.h1`
  font-size: 28px;
  line-height: 30px;
  margin-top: 40px;
  text-transform: uppercase;
  color: ${BLACK};

  ${media.tabletL`
    font-size: 48px;
    line-height: 50px;
    margin-top: 60px;
  `};
`;

export const NameSuffix = styled.span`
  margin-left: 0.25em;
`;



// WEBPACK FOOTER //
// ./src/pages/HairDiagnosis/HairDiagnosisResultPage/Hero/Hero.style.js